import { useEffect, useRef } from "react";
import toast from "react-hot-toast";
import { updateOrgInvite } from "../mutations";
import { IReduxState } from "../state/reducers/root.reducer";
import { getCurrentEnvironment } from "../state/relay-environment";
import { track, TrackingEvents } from "../util/analytics.util";

type SendInvites = IReduxState["webExtension"]["sendInvites"];

export const useSendInvitesToNonUser = (sendInvites: SendInvites, orgId: string | undefined) => {
  const prevSendInvitesMillisRef = useRef(sendInvites.millis);
  const environment = getCurrentEnvironment();

  const sendInvitesToNonUsers = (calendarIds: string[]) => {
    if (!orgId) return;

    updateOrgInvite(
      environment,
      { calendarIds: calendarIds, orgRelayId: orgId },
      () => {
        toast.success("Invite sent!");
      },
      () => {
        toast.error("Invite failed, please contact support");
      },
    );
  };

  useEffect(() => {
    // Event triggered when user hits "invite user" in the event gcal modal
    if (sendInvites.millis > prevSendInvitesMillisRef.current) {
      if (sendInvites?.eventMeta?.externalEventId && sendInvites?.eventMeta?.calendarId) {
        track(TrackingEvents.SCHEDULING.GCAL_ATTENDEES_INVITED_TO_CLOCKWISE, {
          externalEventId: sendInvites.eventMeta.externalEventId,
          calendarId: sendInvites.eventMeta.calendarId,
        });
      }
      sendInvitesToNonUsers(sendInvites.calendarIds);
    }

    prevSendInvitesMillisRef.current = sendInvites.millis;
  }, [sendInvites.millis]);
};
